module.exports = __webpack_public_path__ + "media/images/arrow-down-gold-4e7844c833b558c0871b815ea02f10df.svg";